<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="liCnt">
          <a :href="calUri" class="li" target="_blank">
            <div class="icon google"></div> Google Calendar
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" v-if="1>2"
            class="li" target="_blank">
            <div class="icon apple"></div> Apple Calendar
          </a>
          <a :href="calUri3" class="li" target="_blank">
            <div class="icon office"></div> Office 365
          </a>
          <a :href="calUri2" class="li" target="_blank" v-if="1>2">
            <div class="icon outlook"></div> Outlook Live
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" v-if="1>2"
            class="li" target="_blank">
            <div class="icon outlook"></div> Outlook Desktop
          </a>
          <a href="https://nutrilite.co.id/youthfuelsummerfest.ics" v-if="1>2"
            class="li" target="_blank">
            <div class="icon other"></div> Other Calendar
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
    calUri() {
      const uri = 'https://calendar.google.com/calendar/u/0/r/eventedit?'
        + 'text=Launching Portal Putusan: I-LEAD (Indonesia Landmark Environmental Decisions'
        + '&dates=20230126T010000.000Z/20230126T050000.000Z'
        + '&ctz=Asia/Jakarta'
        + '&details=Portal Putusan Lingkungan Hidup merupakan sebuah situs '
        + 'yang akan menghimpun dokumen, analisis hukum dan pandangan ahli '
        + 'terhadap kasus lingkungan hidup terpilih yang diputus di pengadilan. '
        + 'Portal ini dibentuk sejak awal tahun 2022. Putusan terpilih dalam '
        + 'portal ini diseleksi menurut kriteria sebagai putusan yang memuat '
        + 'pertimbangan hakim, argumen para pihak, dan/atau pembuktian yang '
        + 'penting untuk menjadi pembelajaran bagi perkembangan '
        + 'hukum lingkungan di Indonesia.'
        + `&location=${escape('The Sultan Hotel & Residence, Jakarta')}`
        // + '&pli=1'
        + '&uid=ilead_launching';
        // + '&sf=true'
        // + '&output=xml';
      return uri;
    },
    calUri2() {
      const uri = 'https://outlook.live.com/calendar/0/deeplink/compose?'
        + 'body=Portal%20Putusan%20Lingkungan%20Hidup%20merupakan%20sebuah'
        + '%20situs%20yang%20akan%20menghimpun%20dokumen%2C%20analisis%20hu'
        + 'kum%20dan%20pandangan%20ahli%20terhadap%20kasus%20lingkungan%20h'
        + 'idup%20terpilih%20yang%20diputus%20di%20pengadilan.%0APortal%20i'
        + 'ni%20dibentuk%20sejak%20awal%20tahun%202022.%20Putusan%20terpili'
        + 'h%20dalam%20portal%20ini%20diseleksi%20menurut%20kriteria%20sebag'
        + 'ai%20putusan%20yang%20memuat%20pertimbangan%20hakim%2C%20argume'
        + 'n%20para%20pihak%2C%20dan%2Fatau%20pembuktian%20yang%20penting%20u'
        + 'ntuk%20menjadi%20pembelajaran%20bagi%20perkembangan%20hukum%20lingku'
        + 'ngan%20di%20Indonesia.&enddt=2023-01-26T05%3A00%3A00%2B00%3A00&locati'
        + 'on=The%20Sultan%20Hotel%20%26%20Residence%2C%20Jakarta&path=%2Fcalend'
        + 'ar%2Faction%2Fcompose&rru=addevent&startdt=2023-01-26T01%3A00%3A00%2'
        + 'B00%3A00&subject=Launching%20Portal%20Putusan%3A%20I-LEAD%20%28Indone'
        + 'sia%20Landmark%20Environmental%20Decisions';
      return uri;
    },
    calUri3() {
      const uri = 'https://outlook.office.com/calendar/0/deeplink/compose?'
        + 'body=Portal%20Putusan%20Lingkungan%20Hidup%20merupakan%20sebuah'
        + '%20situs%20yang%20akan%20menghimpun%20dokumen%2C%20analisis%20hu'
        + 'kum%20dan%20pandangan%20ahli%20terhadap%20kasus%20lingkungan%20h'
        + 'idup%20terpilih%20yang%20diputus%20di%20pengadilan.%0APortal%20i'
        + 'ni%20dibentuk%20sejak%20awal%20tahun%202022.%20Putusan%20terpili'
        + 'h%20dalam%20portal%20ini%20diseleksi%20menurut%20kriteria%20sebag'
        + 'ai%20putusan%20yang%20memuat%20pertimbangan%20hakim%2C%20argume'
        + 'n%20para%20pihak%2C%20dan%2Fatau%20pembuktian%20yang%20penting%20u'
        + 'ntuk%20menjadi%20pembelajaran%20bagi%20perkembangan%20hukum%20lingku'
        + 'ngan%20di%20Indonesia.&enddt=2023-01-26T05%3A00%3A00%2B00%3A00&locati'
        + 'on=The%20Sultan%20Hotel%20%26%20Residence%2C%20Jakarta&path=%2Fcalend'
        + 'ar%2Faction%2Fcompose&rru=addevent&startdt=2023-01-26T01%3A00%3A00%2'
        + 'B00%3A00&subject=Launching%20Portal%20Putusan%3A%20I-LEAD%20%28Indone'
        + 'sia%20Landmark%20Environmental%20Decisions';
      return uri;
    },
  },
  methods: {
    open(d, n) {
      this.show = true;
    },
    close(b, d) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .userModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;
    @media (max-width: 680px) {
      padding: 20px 10px;
    }
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background: #fff;
      width: 260px;
      margin: auto;
      border-radius: 5px;
      padding: 40px 100px;
      overflow: hidden;
      transition: all .3s ease;
      .close{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;
        right: 10px;
        top: 10px;
        opacity: .4;
        cursor: pointer;
        transition: all .2s linear;
      }
      .close:hover{
        background-color: #e5e5e5;
        opacity: .7;
      }
      .liCnt{
        margin: 0 -100px;
        .li{
          list-style: none;
          padding: 12px 100px;
          font-size: 18px;
          cursor: pointer;
          color: #444;
          transition: all .3s ease;
          position: relative;
          display: block;
          font-weight: 500;
          text-decoration: none;
          @media (max-width: 680px) {
            padding: 12px 16px;
            padding-left: 80px;
          }
          .icon{
            position: absolute;
            left: 54px; top: 0; bottom: 0; width: 24px;
            background-position: center;
            background-size: 100% auto;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              left: 34px;
            }
            &.google{
              background-image: url(../assets/google.png);
            }
            &.apple{
              background-image: url(../assets/apple.png);
            }
            &.outlook{
              background-image: url(../assets/outlook.png);
            }
            &.office{
              background-image: url(../assets/office.png);
            }
            &.other{
              background-image: url(../assets/calendar.png);
            }
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
  }
</style>
